<script setup lang="ts">

interface Props {
  title: string;
  icon: string;
}

const props = defineProps<Props>();

const isOpen = ref(false);

function open() {
  isOpen.value = true;
}

function close() {
  isOpen.value = false;
}

</script>

<template>
  <IonItem
    button
    lines="full"
    :detail="false"
    @click="open"
  > 
    <IonIcon
      slot="start"
      :class="icon" 
    /> 

    <IonLabel class="text">
      {{ title }}
    </IonLabel>
    <IonIcon
      slot="end"
      class="fa-light fa-angle-right"
    />
  </IonItem>

  <Modal
    :open="isOpen"
    :title="title"
    animation-direction="horizontal"
    @update:open="close"
  >
    <IonContent>
      <slot />
    </IonContent>
  </Modal>
</template>

<style scoped> 
   
ion-icon {
  padding: 0.2rem 0rem; 
}
</style>
